export * from './dotindicator.component';
export * from './navbutton.component';
export * from './pageslider.component';
export * from './render.component';
export * from './dotindicator.component';
// export * from './pageslider.module';
export * from './types';
export * from './events';
